import { fromEvent, map } from "rxjs";

class Select {
    constructor(element){
        this.select$ = fromEvent(element, 'change').pipe(
            map((event) =>  event.target.value)
        );
    }

    getObservable(){
        return this.select$;
    }
}

export default Select;